module.exports = __webpack_public_path__ + "static/media/licenta28.3b28c23c.png";